import cache_version from "cache_version.json";
import { Urls } from "interfaces/urls.interface";

export const urls: Urls = {
    API_HOST_URL: "https://api.internetpoverty.io",
    API_SUBREGION_URL: "https://v2-api.internetpoverty.io",
    cacheVersion: cache_version
};
